import { render, staticRenderFns } from "./Remove.vue?vue&type=template&id=8e4bb1a0&scoped=true&"
import script from "./Remove.vue?vue&type=script&lang=js&"
export * from "./Remove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4bb1a0",
  null
  
)

export default component.exports